<template>
  <div>
    <p
      style="
        font-size: 24px;
        font-weight: bold;
        display: inline-block;
        vertical-align: middle;
      "
    >
      {{ isEditMetadataMode ? "Edit Document" : "Upload Documents" }}
    </p>
    <q-select
      v-show="!isEditMetadataMode"
      filled
      label="Upload Scope"
      style="width: 95%; margin-bottom: 36px"
      v-model="uploadScope"
      :options="uploadScopeOptions"
      :disable="disableUpload || !userUploadAccessLevel"
    />
    <hr
      style="
        width: 95%;
        margin-left: 0px;
        margin-right: 0px;
        color: #e9e9e9;
      "
    />
  </div>
  <div class="q-gutter-lg" style="padding-top: 24px">
    <div v-for="uploadScopeField in uploadScopeFields" :key="uploadScopeField">
      <p style="font-weight: bold; margin-bottom: 8px">
        {{uploadScopeField.label}} 
        <span v-if="uploadScopeField.label.includes('School Name')">
          (<a href="./Historical School Names for Assets List.pdf" target="_blank">School Name History</a>)
        </span>
      </p>
      <span v-if="uploadScopeField.scopeField === 'label' && labelExtension !== ''">
        <q-input
          :ref="uploadScopeField.ref"
          outlined
          style="width: 90%; display: inline-block;"
          clearable
          lazy-rules
          :rules="uploadScopeField.required"
          hide-bottom-space
          v-model="uploadScopeField.value"
          :disable="disableUpload || !userEditAccessLevel"
        />
        .{{labelExtension}}
      </span>
      <q-input
        v-if="uploadScopeField.options == null && uploadScopeField.scopeField !== 'report_date' && (uploadScopeField.scopeField !== 'label' || labelExtension === '')"
        :ref="uploadScopeField.ref"
        outlined
        style="width: 95%"
        clearable
        lazy-rules
        :rules="uploadScopeField.required"
        hide-bottom-space
        v-model="uploadScopeField.value"
        :disable="disableUpload || !hasAccessLevel"
      />
      <q-select
        v-if="uploadScopeField.options != null && !uploadScopeField.multipleFields"
        :ref="uploadScopeField.ref"
        outlined
        style="width: 95%"
        clearable
        lazy-rules
        :rules="uploadScopeField.required"
        hide-bottom-space
        v-model="uploadScopeField.value"
        use-input
        hide-selected
        fill-input
        input-debounce="0"
        menu-anchor="top middle"
        menu-self="bottom middle"
        :options="uploadScopeField.options"
        @filter="uploadScopeField.filter"
        :disable="disableUpload || !hasAccessLevel"
      />
      <q-select
        v-if="uploadScopeField.options != null && uploadScopeField.multipleFields"
        :ref="uploadScopeField.ref"
        outlined
        style="width: 95%"
        clearable
        lazy-rules
        :rules="uploadScopeField.required"
        hide-bottom-space
        v-model="uploadScopeField.value"
        use-input
        use-chips
        multiple
        fill-input
        input-debounce="0"
        menu-anchor="top middle"
        menu-self="bottom middle"
        :options="uploadScopeField.options"
        @filter="uploadScopeField.filter"
        :disable="disableUpload || !hasAccessLevel"
      />
      <q-input
        v-if="uploadScopeField.scopeField === 'report_date'"
        :ref="uploadScopeField.ref"
        outlined
        style="width: 95%"
        clearable
        lazy-rules
        :rules="uploadScopeField.required"
        v-model="formattedDateModel"
        hint="MM-DD-YYYY"
        :disable="disableUpload || !hasAccessLevel"
      >
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy transition-show="scale" transition-hide="scale">
              <q-date v-model="dateModel" mask="MM-DD-YYYY" multiple minimal>
                <div class="row justify-end">
                  <q-btn v-close-popup label="Close" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <q-file
      v-show="isEditMetadataMode"
      ref="filesRef"
      class="qFileStyle"
      style="
        width: 100%;
        max-width: 398px;
        padding-top: 12px;
      "
      v-model="files"
      label="Optional: Replace the existing file"
      outlined
      filled
      use-chips
      append
      hide-bottom-space
      :disable="disableUpload || !userEditAccessLevel"
    >
      <template v-slot:prepend>
        <q-icon name="attach_file" />
      </template>
    </q-file>
    <q-file
      v-show="!isEditMetadataMode"
      ref="filesRef"
      class="qFileStyle"
      style="
        width: 100%;
        max-width: 398px;
        padding-top: 12px;
      "
      v-model="files"
      label="Choose File(s)"
      outlined
      filled
      use-chips
      multiple
      append
      lazy-rules
      :rules="requiredRules"
      hide-bottom-space
      :disable="disableUpload || !userUploadAccessLevel"
    >
      <template v-slot:prepend>
        <q-icon name="attach_file" />
      </template>
    </q-file>
    <q-checkbox v-show="displayUnzipOption" v-model="unzipOption" label="Unzip file(s) when uploading" :disable="disableUpload || !userUploadAccessLevel" />
  </div>

  <div style="margin-top: 36px">
    <hr
      style="
        width: 95%;
        margin-left: 0px;
        margin-right: 0px;
        color: #e9e9e9;
      "
    />
    <p style="font-weight: bold; margin-bottom: 8px; padding-top: 24px">
      Folder (<a @click="openFolderDialog" style="color:#0067C1;cursor: pointer;">Select</a>)
    </p>
    <q-input
      outlined
      style="width: 95%"
      clearable
      hide-bottom-space
      v-model="folder"
      :disable="disableUpload || !hasAccessLevel"
    />
  </div>

  <div v-if="userUserGroupAccessAccessLevel">
    <p style="font-weight: bold; margin-bottom: 8px; padding-top: 24px">
      User Group Access
    </p>
    <q-select
      outlined
      v-model="userGroups"
      use-input
      use-chips
      multiple
      input-debounce="0"
      :options="userGroupsOptions"
      @filter="filterUserGroups"
      style="width: 95%;"
      :disable="disableUpload || !hasAccessLevel"
    />
  </div>

  <div
    class="q-gutter-x-md"
    style="
      padding-top: 40px;
      margin-right: 20px;
      display: flex;
      justify-content: right;
    "
  >
    <q-btn
      v-show="!isEditMetadataMode"
      flat
      label="Clear"
      class="text-bold"
      padding="sm"
      no-caps
      style="padding: 8px 16px"
      v-close-popup
      @click="clearUploadInputs"
      :disabled="disableUpload || !userUploadAccessLevel"
    />
    <q-btn
      v-show="!isEditMetadataMode"
      unelevated
      label="Upload"
      text-color="white"
      class="text-bold"
      icon="file_upload"
      padding="sm"
      no-caps
      style="background: #0067c1; padding: 0px 24px"
      v-close-popup
      @click="submitUpload"
      :disabled="disableUpload || !userUploadAccessLevel"
    />
    <q-btn
      v-show="isEditMetadataMode"
      flat
      label="Cancel"
      class="text-bold"
      padding="sm"
      no-caps
      style="padding: 8px 16px"
      v-close-popup
      @click="cancelEditMetadataMode"
      :disabled="disableUpload || !userEditAccessLevel"
    />
    <q-btn
      v-show="isEditMetadataMode"
      unelevated
      label="Update"
      text-color="white"
      class="text-bold"
      padding="sm"
      no-caps
      style="background: #0067c1; padding: 0px 24px"
      v-close-popup
      @click="submitEditMetadata"
      :disabled="disableUpload || !userEditAccessLevel"
    />
  </div>

  <q-dialog v-model="folderDialog">
    <q-card
      class="resultsModal"
      style="min-width: 100%; min-height: 100%; border-radius: 10px"
    >
      <q-card-section align="center">
        <div style="float: right"><q-btn icon="close" flat round dense v-close-popup class="circle-btn text-primary" style="margin-bottom: 0px" /></div>
      </q-card-section>

      <q-card-section>
        <q-input dense filled v-model="folderFilter" label="Filter" style="width: 20%"/>
        <q-tree
          :nodes="folderNodes"
          v-model:expanded="expandedFolderNodes"
          node-key="nodeKey"
          :filter="folderFilter"
          v-model:selected="folder"
          style="cursor: pointer;"
          v-if="folderNodes"
        />
      </q-card-section>

      <q-card-actions align="center">
        <q-btn
          label="New Folder"
          text-color="white"
          style="margin-right: 20px; background: #0067c1"
          @click="addNewFolder"
          no-caps
        />

        <q-btn
          label="Close"
          text-color="white"
          style="margin-right: 20px; background: #0067c1"
          no-caps
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { computed, onBeforeMount, ref, watch } from "vue";
import SchoolMap from "../../assets/CPT-Map-School-LOC.json";
import CommonHelper from "../helper/CommonHelper.js";
import NotificationHelper from "../helper/NotificationHelper";
import pako from "pako";
import APIKeyService from "../service/APIKeyService.js";
import EmailService from "../service/EmailService.js";
import LogService from "../service/LogService.js";
import MayanService from "../service/MayanService.js";
import axios from "axios";
import moment from "moment";
import 'setimmediate';

export default {
  name: "UploadContainer",
  props: {
    searchScopeOptionsArray: Array,
    userUserGroupAccessAccessLevel: Boolean,
    userUploadAccessLevel: Boolean,
    userEditAccessLevel: Boolean,
    currentUserUID: String,
    ipAddress: String,
    sideBarMode: String,
    metadata: Object,
    foldersTable: Object,
    filePreview: Object
  },
  emits: ["setSideBarMode"],
  setup(props, { emit }) {
    const hasAccessLevel = computed(() => {
      return props.userUploadAccessLevel || props.userEditAccessLevel;
    });

    const uploadScopeOptions = computed(() => {
      return props.searchScopeOptionsArray.filter((searchScopeOption) => {
        return CommonHelper.checkScopeUpload(searchScopeOption);
      });
    });

    const uploadScope = ref(null);
    const uploadScopeFields = ref([]);

    watch(
      () => CommonHelper.selectedSearchScopeOptions.value,
      () => {
        if (!CommonHelper.selectedSearchScopeOptions.value.includes(uploadScope.value)) {
          let scope = CommonHelper.selectedSearchScopeOptions.value.find((searchScopeOption) => {
            if (CommonHelper.checkScopeUpload(searchScopeOption)) {
              return searchScopeOption;
            }
          });

          if (scope) {
            uploadScope.value = scope;
          }
        }
      },
      { deep: true, immediate: true }
    );

    watch(uploadScope, () => {
      if (!CommonHelper.selectedSearchScopeOptions.value.includes(uploadScope.value)) {
        CommonHelper.addSelectedSearchScopeOption(uploadScope.value);
      }

      if (metadataToEdit.value === null) {
        setUploadScopeFields(uploadScope.value);
      }
    });

    watch(
      () => props.sideBarMode,
      () => {
        if (props.sideBarMode === "uploadFolders" && props.foldersTable) {
          if (props.foldersTable.currentScope && CommonHelper.checkScopeUpload(props.foldersTable.currentScope)) {
            uploadScope.value = props.foldersTable.currentScope;
          }

          if (props.foldersTable.currentFolderStructure && props.foldersTable.currentFolderStructure !== "*") {
            folder.value = props.foldersTable.currentFolderStructure;
          } else {
            folder.value = null;
          }
        }

        if (props.sideBarMode === "upload" || props.sideBarMode === "uploadFolders") {
          if (uploadScopeFields.value.length === 0) {
            setUploadScopeFields(uploadScope.value);
          }
        }
      },
      { deep: true, immediate: true }
    );

    /*
     * Sets the uploadScopeFields from the given scopeFields
     */
    function setUploadScopeFields(scope) {
      uploadScopeFields.value = [];

      var filteredScopeFields = CommonHelper.getScopeFields(scope).filter((scopeField) => {
        return scopeField !== "date" && scopeField !== "location" && scopeField !== "scope";
      });

      if (!isEditMetadataMode.value) {
        filteredScopeFields = filteredScopeFields.filter((scopeField) => {
          return scopeField !== "label";
        });
      }

      filteredScopeFields.forEach((scopeField) => {
        uploadScopeFields.value.push(getUploadScopeField(scopeField));
      });
    };

    const dateModel = ref([]);
    const formattedDateModel = computed({
      get() {
        if (dateModel.value) {
          return dateModel.value.join(", ");
        } else {
          return "";
        }
      },
      set(newValue) {
        if (newValue) {
          dateModel.value = Array.isArray(newValue) ? newValue : newValue.split(", ");
        } else {
          dateModel.value = [];
        }
      }
    });

    /*
     * Watch on dateModel to remove duplicates and sort dates
     */
    watch(dateModel, () => {
      if (dateModel.value && dateModel.value.every(CommonHelper.isValidDate)) {
        const filteredArray = removeDuplicates(dateModel.value);
        if (!arrayEquals(dateModel.value, filteredArray)) {
          dateModel.value = filteredArray;
        }
        dateModel.value.sort((a, b) => {
          const dateX = moment(a, "MM-DD-YYYY").toDate();
          const dateY = moment(b, "MM-DD-YYYY").toDate();
          return dateX > dateY ? 1 : dateX < dateY ? -1 : 0;
        });
      }
    });

    /*
     * Returns an array with no duplicate elements
     */
    function removeDuplicates(array) {
      return array.filter((item, index) => array.indexOf(item) === index);
    }

    /*
     * Returns true when two arrays have the same elements; Otherwise, returns false
     */
    function arrayEquals(a, b) {
      return a.length === b.length && a.every((val, index) => val === b[index]);
    }

    /*
     * Returns an uploadScopeField from the given scopeField
     */
    function getUploadScopeField(scopeField) {
      var label = "";
      var ref = "";
      var required = null;
      var options = null;
      var filter = null;
      var multipleFields = false;

      switch (scopeField) {
        case "action_category":
          label = "Category";
          ref = "uploadActionCategoryRef";
          options = CommonHelper.actionCategoryOptions;
          filter = CommonHelper.filterActionCategory;
          multipleFields = true;
          break;
        case "company_name":
          label = "Company Name *";
          ref = "uploadCompanyNameRef";
          options = CommonHelper.companyNameOptions;
          filter = CommonHelper.filterCompanyName;
          required = requiredRules;
          break;
        case "delivery_party":
          label = "Delivery Party";
          break;
        case "description":
          label = "Description";
          break;
        case "document_category":
          label = "Document Category";
          options = CommonHelper.documentCategoryOptions;
          filter = CommonHelper.filterDocumentCategory;
          break;
        case "file_type":
          if (!uploadScope.value.includes("HIDOE Drawings")) {
            label = "Type *";
            ref = "uploadFileTypeRef";
            options = CommonHelper.fileTypeOptions;
            filter = CommonHelper.filterFileType;
            required = requiredRules;
          } else {
            label = "Type";
          }
          break;
        case "file_year":
          label = "Year";
          break;
        case "invoice_number":
          label = "Invoice Number";
          break;
        case "island":
          label = "Island *";
          ref = "uploadIslandRef";
          options = CommonHelper.islandOptions;
          filter = CommonHelper.filterIsland;
          required = requiredArrayRules;
          multipleFields = true;
          break;
        case "job_number":
          label = "Job Number";
          break;
        case "label":
          label = "Document Name *";
          ref = "uploadLabelRef";
          required = requiredRules;
          break;
        case "location_id":
          label = uploadScope.value !== "Maui Fire Claims 2023" ? "School Name *" : "School Name";
          ref = "uploadLocationIdRef";
          options = CommonHelper.schoolOptions;
          filter = CommonHelper.filterSchool;
          multipleFields = true;

          if (uploadScope.value !== "Maui Fire Claims 2023") {
            required = requiredArrayRules;
          }
          break;
        case "project_number":
          label = "Project Number";
          break;
        case "purchase_order_number":
          label = "Purchase Order Number";
          break;
        case "purchase_order_originator":
          label = "Purchase Order Originator";
          break;
        case "report_date":
          label = "Report Date *";
          ref = "uploadReportDateRef";
          required = requiredDateRules;
          break;
        case "service_contract_type":
          label = "Service Contract Type *";
          ref = "uploadServiceContractTypeRef";
          options = CommonHelper.serviceContractTypeOptions;
          filter = CommonHelper.filterServiceContractType;
          required = requiredRules;
          break;
        case "vendor_or_supplier":
          label = "Vendor or Supplier";
          break;
        case "work_order_number":
          label = "Work Order Number";
          break;
      }

      var uploadScopeField =
        {
          scopeField: scopeField,
          label: label,
          ref: ref,
          required: required,
          options: options,
          filter: filter,
          multipleFields: multipleFields,
          value: null
        };

      return uploadScopeField;
    }

    const disableUpload = ref(false);
    const requiredRules = ref([(val) => !!val || "Required"]);
    const requiredArrayRules = ref([(val) => (val ? val.length : 0) > 0 || "Required"]);
    const requiredDateRules = ref([(val) => {
      if (val) {
        const valArray = val.split(", ");
        return CommonHelper.checkValidDateArray(valArray, "MM-DD-YYYY") ? true : "Invalid Date (MM-DD-YYYY) or Delimiter must be ', '";
      } else {
        return "Required";
      }
    }]);

    const labelExtension = ref("");

    const uploadActionCategoryRef = ref();
    const uploadCompanyNameRef = ref();
    const uploadFileTypeRef = ref();
    const uploadIslandRef = ref();
    const uploadLabelRef = ref();
    const uploadLocationIdRef = ref();
    const uploadReportDateRef = ref();
    const uploadServiceContractTypeRef = ref();
    const files = ref(null);
    const filesRef = ref();

    const metadataToEdit = computed(() => {
      return (props.sideBarMode === "editMetadata" || props.sideBarMode === "editMetadataFolders") ? props.metadata : null;
    });

    watch(metadataToEdit, () => {
      if (metadataToEdit.value !== null) {
        uploadScope.value = metadataToEdit.value.scope;

        setUploadScopeFields(metadataToEdit.value.scope);

        uploadScopeFields.value.forEach((uploadScopeField) => {
          if (uploadScopeField.scopeField === "label") {
            const label = props.metadata[uploadScopeField.scopeField];
            const labelExtensionIndex = label.lastIndexOf('.');

            if (labelExtensionIndex > 0) {
              uploadScopeField.value = label.substr(0, labelExtensionIndex);
              labelExtension.value = label.substr(labelExtensionIndex + 1);
            } else {
              uploadScopeField.value = label;
              labelExtension.value = "";
            }
          } else if (uploadScopeField.scopeField === "report_date") {
            dateModel.value = props.metadata[uploadScopeField.scopeField] ? props.metadata[uploadScopeField.scopeField].split(", ") : [];
          } else if (uploadScopeField.multipleFields) {
            uploadScopeField.value = props.metadata[uploadScopeField.scopeField] ? props.metadata[uploadScopeField.scopeField].split("; ") : [];
          } else {
            uploadScopeField.value = props.metadata[uploadScopeField.scopeField];
          }
        });

        folder.value = metadataToEdit.value.folder_structure ? metadataToEdit.value.folder_structure : null;

        if (metadataToEdit.value.access_user_group_uid) {
          userGroups.value = [];
          const accessUserGroupUidMetadata = metadataToEdit.value.access_user_group_uid.split(":::");
          accessUserGroupUidMetadata.forEach((accessUserGroupUid) => {
            const accessUserGroupUidObject = userGroupsOptionsArray.value.find((option) => {
              return option.userGroupUid === accessUserGroupUid;
            });
            if (accessUserGroupUidObject) {
              userGroups.value.push(accessUserGroupUidObject);
            }
          });
          userGroups.value = CommonHelper.sortArrayOfObjects(userGroups.value);
        } else {
          userGroups.value = [];
        }

        files.value = null;
      } else {
        setUploadScopeFields(uploadScope.value);
        clearUploadInputs();
      }
    });

    function setDisableUpload(value) {
      disableUpload.value = value;
    }

    const isEditMetadataMode = computed(() => {
      return metadataToEdit.value !== null;
    });

    const unzipOption = ref(false);

    const displayUnzipOption = computed(() => {
      let returnValue = false;

      if (!isEditMetadataMode.value && files.value !== null) {
        returnValue = files.value.some(file => file.name.endsWith(".zip"));
      }

      return returnValue;
    })

    const folder = ref(null);
    const folderDialog = ref(false);
    const folderFilter = ref("");
    const expandedFolderNodes = ref([]);

    watch(folder, () => {
      if (folder.value) {
        const folderStructureArray = folder.value.split("/");

        let folderStructure = "";

        for (let i = 0; i < folderStructureArray.length - 1; i++) {
          folderStructure = folderStructure ? `${folderStructure}/${folderStructureArray[i]}` : folderStructureArray[i];

          expandedFolderNodes.value.push(folderStructure);
        }
      } else {
        expandedFolderNodes.value = [];
      }
    });

    function addNewFolder() {
      if (folder.value) {
        folder.value = `${folder.value}/New Folder`;
      } else {
        folder.value = "New Folder";
      }
    }

    const folderNodes = computed(() => {
      if (props.foldersTable && uploadScope.value) {
        return convertRowDictionaryToNodes(props.foldersTable.rowDictionary[uploadScope.value], null);
      } else {
        return null;
      }
    });

    function convertRowDictionaryToNodes(storedFolder, parentFolderStructure) {
      let returnValue = [];

      if (storedFolder) {
        let folders = Object.keys(storedFolder.folders).sort();

        folders.forEach(async (folder) => {
          let folderStructure = parentFolderStructure ? `${parentFolderStructure}/${folder}` : folder;
          let children = convertRowDictionaryToNodes(storedFolder.folders[folder], folderStructure);
          returnValue.push({ label: folder, icon: 'folder', nodeKey: folderStructure, children: children });
        });
      }

      return returnValue;
    }

    function openFolderDialog() {
      if (!disableUpload.value && hasAccessLevel.value) {
        folderDialog.value = true;
      }
    }

    const userGroups = ref([]);
    const userGroupsOptionsArray = ref([]);
    const userGroupsOptions = ref([]);

    onBeforeMount(async () => {
      getUserGroups();
    })

    async function getUserGroups() {
      try {
        const response = await CommonHelper.getUserGroups(false);

        if (response && response.length > 0) {
          response.forEach((userGroup) => {
            userGroupsOptionsArray.value.push({
              label: userGroup.name,
              userGroupUid: userGroup.uid
            });
          });
        }
      } catch (error) {
        EmailService.sendErrorEmail("UploadContainer.vue - getUserGroups", error);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
      }
    }

    /*
     * Filter function for the User Groups dropdown
     */
    function filterUserGroups(val, update) {
      CommonHelper.filterObjectOptions(val, update, userGroupsOptions, userGroupsOptionsArray.value);
    }

    const documentTypeDictionary = JSON.parse(process.env.VUE_APP_DOCUMENT_TYPE_IDS);

    const fileUploadMode = ref("");
    const fileUploading = ref({});

    const fileUploadingInProgress = computed(() => {
      return Object.values(fileUploading.value).some(value => value);
    });

    watch(fileUploadingInProgress, () => {
      if (!fileUploadingInProgress.value) {
        if (fileUploadMode.value === "Add") {
          NotificationHelper.dismiss();
          NotificationHelper.createSuccessNotification("File(s) Successfully Uploaded");
        } else if (fileUploadMode.value === "Update") {
          cancelEditMetadataMode();
          NotificationHelper.dismiss();
          NotificationHelper.createSuccessNotification("Document Successfully Updated");
        }

        files.value = null;

        if (filesRef.value !== null && filesRef.value !== undefined) {
          filesRef.value.resetValidation();
        }

        disableUpload.value = false;
      }
    });

    async function submitUpload() {
      if (!disableUpload.value && props.userUploadAccessLevel) {
        const metadataUploadParameters = getMetadataUploadParameters();

        if (metadataUploadParameters !== null) {
          disableUpload.value = true;

          const metadataDictionary = getMetadataDictionary();
          const documentTypeId = documentTypeDictionary[uploadScope.value];
          const filesValue = files.value;
          const unzipOptionValue = unzipOption.value;
          const folderValue = folder.value;
          const uploadScopeValue = uploadScope.value;

          try {
            fileUploadMode.value = "Add";

            NotificationHelper.createNotification(
              "Uploading File(s)...",
              {
                timeout: 0,
                type: "ongoing",
                color: "primary",
              }
            );

            filesValue.forEach(async (file) => {
              if (file.name.endsWith(".zip") && unzipOptionValue) {
                uploadZipFile(file, documentTypeId, metadataUploadParameters, metadataDictionary, folderValue, uploadScopeValue);
              } else {
                uploadNonZipFile(file, documentTypeId, metadataUploadParameters, metadataDictionary, uploadScopeValue);
              }
            });
          } catch (error) {
            EmailService.sendErrorEmail("UploadContainer.vue - submitUpload", error);
            handleCatch();
          }
        }
      }
    }

    async function submitEditMetadata() {
      if (!disableUpload.value && props.userEditAccessLevel) {
        const metadataUploadParameters = getMetadataUploadParameters();

        if (metadataUploadParameters !== null) {
          disableUpload.value = true;

          const metadataDictionary = getMetadataDictionary();
          const filesValue = files.value;
          const documentId = metadataToEdit.value.id;
          const currentFileCount = metadataToEdit.value.file_count;
          const uploadScopeValue = uploadScope.value;

          try {
            NotificationHelper.createNotification(
              "Updating Document",
              {
                timeout: 0,
                type: "ongoing",
                color: "primary",
              }
            );

            if (filesValue) {
              fileUploadMode.value = "Update";

              const filename = await CommonHelper.getFastifyFilename(filesValue.name);
              const originalfilename = filesValue.name;
              const type = filesValue.type;

              uploadUpdateDocument(documentId, "Update", filename, originalfilename, type, null, filesValue, metadataUploadParameters,
                metadataDictionary, currentFileCount + 1, uploadScopeValue, true, "");
            } else {
              updateTableInput(metadataDictionary, documentId, "Update", null, currentFileCount, uploadScopeValue, "");
              await editMetadata(documentId, "Update", null, metadataUploadParameters, currentFileCount, false);

              cancelEditMetadataMode();

              NotificationHelper.dismiss();
              NotificationHelper.createSuccessNotification("Document Successfully Updated");

              disableUpload.value = false;
            }
          } catch (error) {
            EmailService.sendErrorEmail("UploadContainer.vue - submitEditMetadata", error);
            handleCatch();
          }
        }
      }
    }

    /*
     * Returns a metadata dictionary to update tableInput
     */
    function getMetadataDictionary() {
      let metadataDictionary = {};

      uploadScopeFields.value.forEach((uploadScopeField) => {
        if (uploadScopeField.scopeField === "label") {
          metadataDictionary[uploadScopeField.scopeField] = uploadScopeField.value;

          if (labelExtension.value !== "") {
            metadataDictionary[uploadScopeField.scopeField] = `${metadataDictionary[uploadScopeField.scopeField]}.${labelExtension.value}`;
          }
        } else if (uploadScopeField.scopeField === "location_id") {
          if (uploadScopeField.value) {
            const locationIdArray = uploadScopeField.value.map((schoolName) => {
              return SchoolMap[schoolName].location_id;
            });
            metadataDictionary.location_id_original = locationIdArray.join(":::");
          } else {
            metadataDictionary.location_id_original = "";
          }

          metadataDictionary.location_id = CommonHelper.getSchoolNameArray(metadataDictionary.location_id_original).join("; ");
        } else if (uploadScopeField.scopeField === "report_date") {
          const dateArray = dateModel.value.map((date) => convertDate(date));
          metadataDictionary.report_date_original = dateArray.join(",");
          metadataDictionary.report_date = metadataDictionary.report_date_original ? metadataDictionary.report_date_original.split(",").map((date) => moment(date, "YYYY_MM_DD").format("MM-DD-YYYY")).join(", ") : "";
        } else if (uploadScopeField.multipleFields) {
          metadataDictionary[`${uploadScopeField.scopeField}_original`] = uploadScopeField.value ? uploadScopeField.value.join(":::") : "";
          metadataDictionary[uploadScopeField.scopeField] = metadataDictionary[`${uploadScopeField.scopeField}_original`] ? metadataDictionary[`${uploadScopeField.scopeField}_original`].split(":::").join("; ") : "";
        } else {
          metadataDictionary[uploadScopeField.scopeField] = uploadScopeField.value;
        }
      });

      metadataDictionary.folder_structure = folder.value ? folder.value : "";
      metadataDictionary.access_user_group_uid = userGroups.value.map((obj) => obj.userGroupUid).join(":::");

      return metadataDictionary;
    }

    // Converts date from MM-DD-YYYY to YYYY_MM_DD
    function convertDate(date) {
      const dateArray = date.split("-");
      let newDate = `${dateArray[2]}_${dateArray[0]}_${dateArray[1]}`
      return newDate;
    }

    /*
     * Returns a string containing the metadata upload parameters or null if something is wrong with the parameters
     */
    function getMetadataUploadParameters() {
      var returnValue = "";

      if (!isEditMetadataMode.value) {
        if (files.value === null || files.value.length === 0) {
          NotificationHelper.createErrorNotification("Choose File(s) to upload");
          returnValue = null;
        }
      }

      uploadScopeFields.value.forEach((uploadScopeField) => {
        if (uploadScopeField.value && uploadScopeField.value.length > 0) {
          if (uploadScopeField.scopeField === "label" && returnValue !== null) {
            returnValue += `&${uploadScopeField.scopeField}=${encodeURIComponent(uploadScopeField.value)}`;

            if (labelExtension.value !== "" && isEditMetadataMode.value && files.value) {
              // Update filename extension if the replaced file has a different filename extension than the current filename extension.
              const filenameExtensionIndex = files.value.name.lastIndexOf('.');
              const filenameExtension = files.value.name.substr(filenameExtensionIndex + 1);

              labelExtension.value = filenameExtension;

              returnValue += `.${filenameExtension}`;
            } else if (labelExtension.value !== "") {
              returnValue += `.${labelExtension.value}`;
            }
          } else if (uploadScopeField.scopeField === "location_id" && returnValue !== null) {
            const locationIdArray = uploadScopeField.value.sort().map((schoolName) => {
              return SchoolMap[schoolName].location_id;
            });
            returnValue += `&${uploadScopeField.scopeField}=${locationIdArray.join(":::")}`;
          } else if (uploadScopeField.multipleFields && returnValue !== null) {
            returnValue += `&${uploadScopeField.scopeField}=${encodeURIComponent(uploadScopeField.value.sort().join(":::"))}`;
          } else if (returnValue !== null) {
            returnValue += `&${uploadScopeField.scopeField}=${encodeURIComponent(uploadScopeField.value)}`;
          }
        } else if (uploadScopeField.scopeField === "report_date" && dateModel.value.length > 0) {
          if (CommonHelper.checkValidDateArray(dateModel.value, "MM-DD-YYYY")) {
            if (returnValue !== null) {
              const dateArray = dateModel.value.map((date) => convertDate(date));
              returnValue += `&${uploadScopeField.scopeField}=${dateArray.join(",")}`;
            }
          } else {
            NotificationHelper.createErrorNotification("Report Date is invalid");
            returnValue = null;
          }
        } else if (uploadScopeField.required != null) {
          NotificationHelper.createErrorNotification(`${uploadScopeField.label.replace("*", "")}is required`);
          returnValue = null;
        }
      });

      if (folder.value && returnValue !== null) {
        // trim folders
        folder.value = folder.value.split("/").map(folder => folder.trim()).join("/");

        if (folder.value.includes(":::")) {
          NotificationHelper.createErrorNotification("Folder cannot contain :::");
          returnValue = null;
        } else if (folder.value.startsWith("/")) {
          NotificationHelper.createErrorNotification("Folder cannot start with /");
          returnValue = null;
        } else if (folder.value.endsWith("/")) {
          NotificationHelper.createErrorNotification("Folder cannot end with /");
          returnValue = null;
        } else if (folder.value.includes("//")) {
          NotificationHelper.createErrorNotification("Folder cannot contain //");
          returnValue = null;
        } else if (folder.value) {
          returnValue += `&folder_structure=${encodeURIComponent(folder.value)}`;
        }
      }

      if (userGroups.value.length > 0 && returnValue !== null) {
        returnValue += `&access_user_group_uid=${userGroups.value.map((obj) => obj.userGroupUid).join(":::")}`;
      }

      return returnValue;
    }

    // uploadZipFile will unzip the files and upload to Mayan with metadata
    async function uploadZipFile(file, documentTypeId, metadataUploadParameters, metadataDictionary, folderValue, uploadScopeValue) {
      let blobDictionary = await CommonHelper.readZipFile(file);

      if (blobDictionary) {
        const blobDictionaryKeys = Object.keys(blobDictionary);

        if (blobDictionaryKeys && blobDictionaryKeys.length > 0) {
          blobDictionaryKeys.forEach(async (zipStructure) => {
            let blobArr = blobDictionary[zipStructure];

            blobArr.forEach(async (blobObj) => {
              try {
                let filename = `${zipStructure}\\${blobObj.fileName}`;
                filename = filename.replace(/[^a-zA-Z0-9.:]/g, ':');

                const originalfilename = blobObj.fileName;
                const type = blobObj.mimeType;

                const documentId = await CommonHelper.createEmptyDocument(originalfilename, documentTypeId);

                let alternateFolderStructure = folderValue ? folderValue : file.name.substring(0, file.name.length - 4);

                let metadataUploadParametersCopy = metadataUploadParameters;

                if (folderValue && zipStructure.includes("/")) {
                  let oldFolder = `&folder_structure=${encodeURIComponent(folderValue)}`;

                  let newFolder = `${folderValue}${zipStructure.substring(zipStructure.indexOf("/"))}`;

                  alternateFolderStructure = newFolder;

                  newFolder = `&folder_structure=${encodeURIComponent(newFolder)}`;

                  metadataUploadParametersCopy = metadataUploadParametersCopy.replace(oldFolder, newFolder);
                }

                if (!folderValue) {
                  if (zipStructure.includes("/")) {
                    alternateFolderStructure = `${alternateFolderStructure}${zipStructure.substring(zipStructure.indexOf("/"))}`;
                  }

                  metadataUploadParametersCopy = `${metadataUploadParametersCopy}&folder_structure=${encodeURIComponent(alternateFolderStructure)}`;
                }

                uploadUpdateDocument(documentId, "Add", filename, originalfilename, type, blobObj, null, metadataUploadParametersCopy, metadataDictionary,
                  1, uploadScopeValue, false, alternateFolderStructure);
              } catch (error) {
                EmailService.sendErrorEmail("UploadContainer.vue - uploadZipFile", error);
                handleCatch();
              }
            });
          });
        }
      }
    }

    // upload a file (non zip file type) to Mayan with metadata
    async function uploadNonZipFile(file, documentTypeId, metadataUploadParameters, metadataDictionary, uploadScopeValue) {
      try {
        const filename = await CommonHelper.getFastifyFilename(file.name);
        const originalfilename = file.name;
        const type = file.type;

        const documentId = await CommonHelper.createEmptyDocument(originalfilename, documentTypeId);

        uploadUpdateDocument(documentId, "Add", filename, originalfilename, type, null, file, metadataUploadParameters, metadataDictionary, 1, uploadScopeValue, false, "");
      } catch (error) {
        EmailService.sendErrorEmail("UploadContainer.vue - uploadNonZipFile", error);
        handleCatch();
      }
    }

    function clearUploadInputs() {
      uploadScopeFields.value.forEach((uploadScopeField) => {
        uploadScopeField.value = null;
      });

      if (uploadActionCategoryRef.value !== null && uploadActionCategoryRef.value !== undefined && uploadActionCategoryRef.value.length > 0) {
        uploadActionCategoryRef.value[0].resetValidation();
      }

      if (uploadCompanyNameRef.value !== null && uploadCompanyNameRef.value !== undefined && uploadCompanyNameRef.value.length > 0) {
        uploadCompanyNameRef.value[0].resetValidation();
      }

      if (uploadFileTypeRef.value !== null && uploadFileTypeRef.value !== undefined && uploadFileTypeRef.value.length > 0) {
        uploadFileTypeRef.value[0].resetValidation();
      }

      if (uploadIslandRef.value !== null && uploadIslandRef.value !== undefined && uploadIslandRef.value.length > 0) {
        uploadIslandRef.value[0].resetValidation();
      }

      if (uploadLabelRef.value !== null && uploadLabelRef.value !== undefined && uploadLabelRef.value.length > 0) {
        uploadLabelRef.value[0].resetValidation();
      }

      if (uploadLocationIdRef.value !== null && uploadLocationIdRef.value !== undefined && uploadLocationIdRef.value.length > 0) {
        uploadLocationIdRef.value[0].resetValidation();
      }

      if (uploadReportDateRef.value !== null && uploadReportDateRef.value !== undefined && uploadReportDateRef.value.length > 0) {
        uploadReportDateRef.value[0].resetValidation();
      }

      if (uploadServiceContractTypeRef.value !== null && uploadServiceContractTypeRef.value !== undefined && uploadServiceContractTypeRef.value.length > 0) {
        uploadServiceContractTypeRef.value[0].resetValidation();
      }

      files.value = null;

      if (filesRef.value !== null && filesRef.value !== undefined) {
        filesRef.value.resetValidation();
      }

      dateModel.value = [];

      if (props.sideBarMode !== "uploadFolders") {
        folder.value = null;
      }

      userGroups.value = [];
    }

    async function uploadUpdateDocument(documentId, uploadMode, filename, originalfilename, type, blobObj, file, metadataUploadParameters, metadataDictionary,
        fileCount, uploadScopeValue, fileReplaced, alternateFolderStructure) {

      fileUploading.value[documentId] = true;

      if (originalfilename.endsWith(".zip")) {
        CommonHelper.saveZipFileData(documentId, blobObj ? blobObj.blob : file);
      } else {
        CommonHelper.deleteZipFileData(documentId);
      }

      uploadFile(documentId, uploadMode, filename, originalfilename, type, blobObj, file);
      storeBlobDocumentIdDuringUpload(documentId, type, blobObj, file);
      editMetadata(documentId, uploadMode, originalfilename, metadataUploadParameters, fileCount, fileReplaced);
      updateTableInput(metadataDictionary, documentId, uploadMode, originalfilename, fileCount, uploadScopeValue, alternateFolderStructure);
    }

    async function uploadFile(documentId, uploadMode, filename, originalfilename, type, blobObj, file) {
      try {
        let uploadFormData = new FormData();
        var myBlob = file ? file : new File([blobObj.blob], originalfilename, { type: type });

        // Checks if file is less than 2 GB in bytes; If true, then deflate file.
        if (myBlob.size < 2147483648) {
          const fileAsArrayBuffer = await myBlob.arrayBuffer();
          var compressed_file = pako.deflate(fileAsArrayBuffer, {
            level: 9,
          });
          myBlob = new File([compressed_file], originalfilename, { type: type });
        }

        const tokenResponse = await APIKeyService.generateApiToken();

        uploadFormData.append("file", myBlob, originalfilename);
        uploadFormData.append("apiKey", tokenResponse.apiKey);
        uploadFormData.append("uid", tokenResponse.documentName);
        uploadFormData.append("filename", filename);
        uploadFormData.append("originalfilename", originalfilename);
        uploadFormData.append("documentId", documentId);

        await axios.post(`${process.env.VUE_APP_FASTIFY}uploadToMayanStorage`, uploadFormData);

        fileUploading.value[documentId] = false;

        const fileLatest = CommonHelper.storedFileLatest.value[documentId];

        checkForUpdatedStoredFileLatest(documentId, 0, fileLatest ? fileLatest.length + 1 : 1, uploadMode);
      } catch (error) {
        EmailService.sendErrorEmail("UploadContainer.vue - uploadFile", error);
        handleCatch();
      }
    }

    async function checkForUpdatedStoredFileLatest(documentId, safetyCount, newCount, uploadMode) {
      if (safetyCount < 100) {
        try {
          await CommonHelper.updateStoredFileLatest(documentId, false);

          const fileLatest = CommonHelper.storedFileLatest.value[documentId];

          if (!fileLatest || fileLatest.length < newCount) {
            setTimeout(() => {
              checkForUpdatedStoredFileLatest(documentId, safetyCount + 1, newCount, uploadMode);
            }, 30000);
          } else if (uploadMode === "Update") {
            const record = CommonHelper.tableInput.value.find((i) => {
              if (i.id === documentId) {
                return i;
              }
            });

            if (record && record.file_version_data) {
              const fileVersionData = JSON.parse(record.file_version_data);

              if (fileVersionData.emphasizeFileId && fileVersionData.emphasizeFileId.length > 0) {
                if (fileLatest[1] && fileLatest[1].id === fileVersionData.emphasizeFileId[0]) {
                  const fileId = fileLatest[0].id;

                  fileVersionData.emphasizeFileId = [ fileId ];

                  const fileVersionDataString = JSON.stringify(fileVersionData);

                  record.file_version_data = fileVersionDataString;

                  const response = await MayanService.editFileVersionData(documentId, fileId, "same");

                  LogService.logDocumentChanges(props.currentUserUID, props.ipAddress, "Update", response);
                }
              }
            }
          }
        } catch (error) {
          EmailService.sendErrorEmail("UploadContainer.vue - checkForUpdatedStoredFileLatest", error);
          handleCatch();
        }
      }
    }

    async function storeBlobDocumentIdDuringUpload(documentId, type, blobObj, file) {
      const blob = blobObj ? blobObj.blob : file;

      props.filePreview.removeStoredBlobDocumentId(documentId);
      props.filePreview.storeBlobDocumentIdDuringUpload(documentId, blob, type);
    }

    async function editMetadata(documentId, uploadMode, originalfilename, metadataUploadParameters, fileCount, fileReplaced) {
      try {
        let url = `${process.env.VUE_APP_API_GATEWAY}editMetadata?document_id=${documentId}${metadataUploadParameters}&file_count=${fileCount}&key=${process.env.VUE_APP_API_KEY}`;

        let response = await axios.get(url);

        if (uploadMode === "Add") {
          response.data.document_name = originalfilename;
        }

        if (fileReplaced) {
          response.data.file_replaced = true;
          response.data.filename = `${originalfilename} (${moment().format("MM-DD-YYYY hh:mm a" )})`;
        }

        LogService.logDocumentChanges(props.currentUserUID, props.ipAddress, uploadMode, response);
      } catch (error) {
        EmailService.sendErrorEmail("UploadContainer.vue - editMetadata", error);
        handleCatch();
      }
    }

    /*
     * Updates tableInput
     */
    async function updateTableInput(metadataDictionary, documentId, uploadMode, originalfilename, fileCount, uploadScopeValue, alternateFolderStructure) {
      if (uploadMode === "Add") {
        let metadataDictionaryCopy = {};

        Object.keys(metadataDictionary).forEach((metadata) => {
          metadataDictionaryCopy[metadata] = metadataDictionary[metadata];
        });

        metadataDictionaryCopy.id = documentId.toString();
        metadataDictionaryCopy.label = originalfilename;
        metadataDictionaryCopy.scope = uploadScopeValue;
        metadataDictionaryCopy.datetime_created = moment().format("YYYY-MM-DD");
        metadataDictionaryCopy.file_count = fileCount;

        if (alternateFolderStructure) {
          metadataDictionaryCopy.folder_structure = alternateFolderStructure;
        }

        CommonHelper.addFileInfoDocumentName(metadataDictionaryCopy);

        CommonHelper.tableInput.value.push(metadataDictionaryCopy);
      } else {
        let record = CommonHelper.tableInput.value.find((i) => {
          if (i.id === documentId) {
            return i;
          }
        });

        if (record) {
          Object.keys(metadataDictionary).forEach((metadata) => {
            record[metadata] = metadataDictionary[metadata];
          });

          record.file_count = fileCount;

          CommonHelper.addFileInfoDocumentName(record);
        }
      }
    }

    function handleCatch() {
      NotificationHelper.dismiss();

      if (fileUploadMode.value === "Add") {
        NotificationHelper.createErrorNotification("Upload Failed");
      } else if (fileUploadMode.value === "Update") {
        NotificationHelper.createErrorNotification("Update Failed");
      }

      files.value = null;

      if (filesRef.value !== null && filesRef.value !== undefined) {
        filesRef.value.resetValidation();
      }

      disableUpload.value = false;
    }

    /*
     * Cancels editMetadataMode
     */
    function cancelEditMetadataMode() {
      if (props.sideBarMode === "editMetadataFolders") {
        emit("setSideBarMode", "folders");
      } else {
        emit("setSideBarMode", "singularSearchHidden");
      }
    }

    return {
      //variable properties
      hasAccessLevel,
      uploadScopeOptions,
      uploadScope,
      uploadScopeFields,
      dateModel,
      formattedDateModel,
      disableUpload,
      requiredRules,
      requiredArrayRules,
      labelExtension,
      uploadActionCategoryRef,
      uploadCompanyNameRef,
      uploadFileTypeRef,
      uploadIslandRef,
      uploadLabelRef,
      uploadLocationIdRef,
      uploadReportDateRef,
      uploadServiceContractTypeRef,
      files,
      filesRef,
      metadataToEdit,
      isEditMetadataMode,
      displayUnzipOption,
      unzipOption,
      folder,
      folderDialog,
      folderFilter,
      expandedFolderNodes,
      folderNodes,
      userGroups,
      userGroupsOptions,

      //functions
      addNewFolder,
      openFolderDialog,
      submitUpload,
      submitEditMetadata,
      clearUploadInputs,
      cancelEditMetadataMode,
      setDisableUpload,
      filterUserGroups,

      //helpers
      CommonHelper
    };
  },
};
</script>

<style lang="scss">
.qFileStyle {
  .q-field__control {
    min-height: 100px !important;
  }
}
</style>